import { cookies } from '../configs/cookies';
import { BOOKMARK_OVERLAY_DISMISS_EXPIRE } from '../configs/env';

const BOOKMAR_OVERLAY = 'bookmark-overlay-cookie';

export const dismissedBookmarkOverlay = () => {
  return cookies.has(BOOKMAR_OVERLAY);
};

export const dismissBookmarkOverlay = () => {
  cookies.set(BOOKMAR_OVERLAY, 'dismissed', {
    expires: new Date(Date.now() + BOOKMARK_OVERLAY_DISMISS_EXPIRE * 1000),
    path: '/'
  });
};
